<template>
	<div>
		<div class="">
			{{ jsdata }}
		</div>
	</div>
</template>
<script>
	import {
		getIntegralPay,
		getZiXun
	} from "@api/store";
	import {
		pay
	} from "@libs/wechat";
	export default {
		name: "integral_pay",
		components: {},
		props: {},
		data: function() {
			const {
				openid = "",
					orders_sn = "",
					back_url = "",
					pay_type = ""
			} = this.$route.query;
			return {
				openid: openid,
				orders_sn: orders_sn,
				back_url: back_url,
				pay_type: pay_type,
				jsdata: "",
				merchant_name: ""
			};
		},
		watch: {},
		mounted: function() {
			console.log(this.back_url);
			this.getQiYe();
			setTimeout(() => {
				this.get_pay();
			}, 500);
		},
		methods: {
			getQiYe() {
				getZiXun().then(res => {
					this.merchant_name = "“" + res.data.merchant_name + "”";
				});
			},
			get_pay() {
				var that = this
				getIntegralPay({
					openid: this.openid,
					orders_sn: this.orders_sn,
					pay_type: this.pay_type
				}).then(res => {
					console.log(123333);
					// this.jsdata = JSON.stringify(res.data.jsConfig);
					console.log(res.data.jsConfig);
					console.log(123333);
					pay(res.data.jsConfig)
						.then(res => {
							console.log(11111111);
							console.log(res);
							console.log(11111111);
							// this.jsdata = "err" + JSON.stringify(res);
							// if (this.pay_type == "integral") {
							var msg = "付款成功";
							// }
							// if (this.pay_type == "vip") {
							//   var msg = "恭喜您，成为" + this.merchant_name + "金钻会员";
							// }
							this.$dialog.alert({
								mes: msg,
								// mes: '恭喜您，成为'+ this.merchant_name +'金钻会员',
								callback: () => {
									// window.location.href = "//" + this.back_url + "/user/vip";
									window.location.href = "//" + this.back_url +
										"/order/detail/" + that.orders_sn;
								}
							});
						})
						.catch(err => {
							// this.jsdata = "err" + JSON.stringify(err);
							console.log(123);
							console.log(err);
							console.log(123123);
						});
					// pay(res.data.jsConfig).finally(() => {
					//     window.location.href = '//' + this.back_url;
					// });
				});
			}
		}
	};
</script>
<style>
	.yd-confirm {
		height: auto !important;
	}
</style>
